<template>
  <div class="header">
    <div class="logo">
      <a>
        <img src="../assets/images/ptb-logo.png"/>
      </a>
    </div>
    <div class="nav">
      <ul>
        <li>
          <router-link to="/">首页</router-link>
        </li>
        <li>
          <router-link to="/ad-style">广告形式</router-link>
        </li>
        <li>
          <router-link to="/advantage">我们的优势</router-link>
        </li>
        <li>
          <router-link to="/example">客户案例</router-link>
        </li>
        <li>
          <router-link to="/about-us">了解我们</router-link>
        </li>
      </ul>
    </div>
    <div class="contract">
      <span>177-2473-1490</span>
      <el-button class="contract-btn" round>立即联系</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped lang="stylus">
  body
    font-family:PingFang SC
    .header
      color: #666666
      background-color: white
      box-sizing: border-box
      padding: 20px 45px
      width: 100%
      position: fixed
      left: 0
      top: 0
      height: 79px
      z-index: 999
      border-bottom: 1px solid #e5e5e5
      div
        display:inline-block
      .logo
        height: 32px
        width: 120px
        float: left
        a,img
          height: 100%
          display: inline-block
      .nav
        margin-left: 10px
        position: relative
        float: left
        ul
          margin-top: 9px
          a
            text-decoration: none
            color: black
            font-size: 16px
          li
            display:inline
            color: black
          li + li
            margin-left: 40px
      .contract
        font-size: 20px
        font-weight: 400
        float: right
        span
          margin-right: 32px
        .contract-btn
          width: 147px
          height: 45px
          background-color: #db1d2d
          border: none
          color: white
          border-radius: 25px
</style>



// WEBPACK FOOTER //
// src/components/Header.vue